// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"styles_layoutWrapper__DF8NX","reg":"styles_reg__SFNzW","reg__image":"styles_reg__image__jmg2I"};